// sanity plug
export const buttonUrlSchema = {
  type: "object",
  title: "Button",
  name: "button",
  fields: [
    {
      name: "label",
      title: "Label",
      type: "string",
    },
    {
      name: "url",
      title: "URL",
      type: "url",
    },
  ],
};

export const buttonLinkSchema = {
  type: "object",
  title: "Button",
  name: "button",
  fields: [
    {
      name: "label",
      title: "Label",
      type: "string",
    },
    {
      name: "url",
      title: "link",
      type: "link",
    },
  ],
};

export const buttonLinkUrlSchema = {
  type: "object",
  title: "Button",
  name: "button",
  fields: [
    {
      name: "label",
      title: "Label",
      type: "string",
    },
    {
      name: "url",
      title: "Link or URL",
      type: "linkUrl",
    },
  ],
};
